@if (isInitialized) {
  <oe-modal [title]="component.alias" [component]="component">
    <!-- Discharge State -->
    <!-- Price -->
    <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRICE' | translate"
      [value]="consumptionPriceWithCurrency"></oe-modal-line>
    <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRODUCTION_PRICE' | translate"
                   [value]="productionPriceWithCurrency"></oe-modal-line>
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <!--Select Mode-->
        <oe-modal-info-line
          [info]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRICES_CHART_TITLE'| translate"></oe-modal-info-line>
        <timeOfUseTariffPriceChart class="ion-padding" [refresh]="refreshChart" [component]="component" [edge]="edge">
        </timeOfUseTariffPriceChart>
  </oe-modal>
}
